import { useAuiState } from '@assistant-ui/react'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AgentActivityRowView } from '@/components/agent/AgentActivityRowView'
import { useAgentActivity } from './AgentActivityContext'

/** Connects {@link AgentActivityRowView} to the thread: activity the host reports
 * wins; otherwise the thread's own run shows the generic label. */
export const AgentActivityRow: FC = () => {
  const { t } = useTranslation()
  const reported = useAgentActivity()
  const isRunning = useAuiState(s => s.thread.isRunning)
  return (
    <AgentActivityRowView
      activity={reported ?? (isRunning ? { label: t('chat.working') } : null)}
    />
  )
}
